<template>
  <div class="tourism-office">
    <div class="navigation-spacer"></div>
    <div class="container page-component">
      <h1>{{ fields.title }}</h1>
      <prismic-rich-text :field="fields.text" />
    </div>
  </div>
</template>

<script>
import EventBus from '../EventBus'

export default {
  name: 'TourismOffice',
  data () {
    return {
      fields: {
        title: null,
        text: null
      }
    }
  },
  methods: {
    async getContent (language) {
      let document = 	await this.$prismic.client.getByUID('pagedescription', 'tourism-office', { lang : language })
      if (document) {
        this.fields.title = document.data.title[0].text
        this.fields.text = document.data.text
      }
    }
  },
  async created () {
    await this.getContent(window.KriensTourismus.language)
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
}
</script>
